<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div v-if="istemplateApplicable == true">
                        <span v-html="rawhtmlcode"></span>
                     </div>
        <!-- <v-card class="box card" flat v-if="leraner_marksheet != ''">
            <v-row dense>
                <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
                    <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
                </v-btn>
            </v-row>

            <div class="div">
                <v-col cols="12">
                    <div>
                        <div class="top-row">
                            <div class="pr-10">
                                <img :src="org_basic_data.school_logo" alt="logo" height="140" width="140" />
                            </div>

                            <div class="text-center">
                                <h5 class="society">{{ org_basic_data.trust_name }}</h5>
                                <h1 class="header-style">Sanjivani <span class="span-first-letter">A</span>cademy</h1>
                                <div class="motto text-center">
                                    <span class="dot">•</span>
                                    <span>Devotion</span>
                                    <span class="dot">•</span>
                                    <span>Determination</span>
                                    <span class="dot">•</span>
                                    <span>Dedication</span>
                                </div>
                                <div class="school-desc mt-2">
                                    (A CBSE Affiliated Senior Secondary Co-Educational English Medium School)
                                </div>
                            </div>
                        </div>
                        <v-row class="align-center affiliation">
                            <v-col cols="6" class="text-left">
                                <b> SA / EXM / R / 10 </b>
                            </v-col>
                            <v-col cols="6" class="text-right">
                                <b> Affiliation No. {{ org_basic_data.cbsc_no }}</b>
                            </v-col>
                        </v-row>


                        <div class="address-row">
                            <div style="text-align: center;">{{ org_basic_data.address }}</div>
                            <v-row dense>
                                <v-col cols="6" align="center">
                                    <span class="text-css">Phone : {{ org_basic_data.phone }}</span>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" align="center">
                                    <span class="text-css">e-mail : {{ org_basic_data.email }}</span>
                                </v-col>
                                <v-col cols="6" align="center">
                                    <span class="text-css">website : {{ org_basic_data.website }}</span>
                                </v-col>
                            </v-row>
                        </div>
                    </div>

                    <div class="report-title-container">
                        <div class="report-title">
                            <h1 class="report-title2">Report Card</h1>

                            <h5 class="subtitle my-3">
                                (Issued by School as per directives of Central Board of Secondary Education,
                                Delhi)
                            </h5>
                            <h2>Academic Year 2024 - 2025</h2>
                        </div>

                        <div class="student-photo">
                            <img v-if="photo" :src="awspath + photo" alt="Student Photo" />
                            <img v-else src="https://eduplusschool.s3.ap-south-1.amazonaws.com/User_avatar.jpeg"
                                alt="Student Photo" />
                        </div>
                    </div>

                    <h2 class="pl-2 pb-2 colored-text">Student Profile</h2>
                    <v-simple-table class="student-info-table">
                        <tbody>
                            <tr>
                                <td class="label">Name of Student</td>
                                <td class="value" colspan="3">{{ name }}</td>
                            </tr>

                            <tr>
                                <td class="label">Grade & Division</td>
                                <td class="value" colspan="3">{{ standard }} - {{ div }}</td>
                            </tr>

                            <tr>
                                <td class="label">Roll No.<br /><small>(Allotted by the School)</small></td>
                                <td class="value" colspan="3">{{ roll_no }}</td>
                            </tr>

                            <tr>
                                <td class="label">G. R. No.<br /><small>(Allotted by the School)</small></td>
                                <td class="value" colspan="3">{{ gr_no }}</td>
                            </tr>

                            <tr>
                                <td class="label">Date of Birth</td>
                                <td class="value" colspan="3">{{ dob }}</td>
                            </tr>
                            <tr>
                                <td class="label">Aadhar Card No.</td>
                                <td class="value" colspan="3">{{ aadhar_no }}</td>
                            </tr>

                            <tr>
                                <td class="label">Mother’s Name</td>
                                <td class="value">{{ mother_name }}</td>
                                <td class="label">Blood Group</td>
                                <td class="value">{{ blood_group }}</td>
                            </tr>

                            <tr>
                                <td class="label">Father’s Name / Guardian’s Name</td>
                                <td class="value" colspan="3">{{ father_full_name }}</td>
                            </tr>

                            <tr>
                                <td class="label">Residential Address</td>
                                <td class="value" colspan="3">{{ address }}</td>
                            </tr>

                            <tr>
                                <td class="label">Contact No.</td>
                                <td class="value" colspan="3">{{ father_contact }} | {{ mother_contact }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <br>
                <v-col cols="12" sm="12" md="12" v-if="leraner_marksheet.display_att == 'True'">
                    <v-simple-table v-if="leraner_marksheet != ''" fixed-header dense
                        class="elevation-1 attd-table student-info-table">
                        <thead>
                            <tr>
                                <td class="colored-text" style="font-size: 20px;">
                                    <center>Attendance</center>
                                </td>
                                <td v-if="leraner_marksheet.is_admitted_for_term_1 == true">
                                    <center>{{ leraner_marksheet.sem1 }}</center>
                                </td>
                                <td>
                                    <center>{{ leraner_marksheet.sem2 }}</center>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="label">
                                    <center>
                                        <strong>Total Attendance </strong>
                                    </center>
                                </td>
                                <td v-for="(s, index2) in leraner_marksheet.sem1_attendance" :key="index2"
                                    v-if="leraner_marksheet.is_admitted_for_term_1 == true">
                                    <center>{{ s.present }}</center>
                                </td>
                                <td v-for="(s, index2) in leraner_marksheet.sem2_attendance" :key="index2">
                                    <center>{{ s.present }}</center>
                                </td>
                            </tr>
                            <tr>
                                <td class="label">
                                    <center>
                                        <strong>Total Attendance Working Days</strong>
                                    </center>
                                </td>
                                <td v-for="(s, index2) in leraner_marksheet.sem1_attendance" :key="index2"
                                    v-if="leraner_marksheet.is_admitted_for_term_1 == true">
                                    <center>{{ s.total_working_stud }}</center>
                                </td>
                                <td v-for="(s, index2) in leraner_marksheet.sem2_attendance" :key="index2">
                                    <center>{{ s.total_working_stud }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <br>
                    <v-img v-if="org_basic_data.school_photo" :src="org_basic_data.school_photo" height="500"
                        width="1500"></v-img>
                </v-col>

            </div>
            <div class="div pagebreak">
                <v-col cols="12" sm="12" md="12">
                    <h2 class="pl-2 pb-2 colored-text">Part - 1 : Scholastic Area</h2>
                    <v-simple-table v-if="leraner_marksheet != ''" dense class="elevation-1">
                        <thead>
                            <tr>
                                <td rowspan="2" style="background-color: #f5e9c9;">
                                    <center>Subject Name</center>
                                </td>
                                <td style="background-color: #f5e9c9;"
                                    v-if="leraner_marksheet.is_admitted_for_term_1 == true"
                                    :colspan="leraner_marksheet.ass_details_for_marksheet.length">
                                    <center>{{ leraner_marksheet.sem1 }}</center>
                                </td>
                                <td style="background-color: #f5e9c9;" :colspan="leraner_marksheet.ass_details_for_marksheet_sem2.length
                                    ">
                                    <center>{{ leraner_marksheet.sem2 }}</center>
                                </td>
                            </tr>

                            <tr>

                                <td style="background-color: #f5e9c9;"
                                    v-for="header in leraner_marksheet.ass_details_for_marksheet" :key="header">
                                    <center>{{ header }}</center>
                                </td>
                                <td style="background-color: #f5e9c9;"
                                    v-for="header in leraner_marksheet.ass_details_for_marksheet_sem2" :key="header">
                                    <center>{{ header }}</center>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(
s, index
            ) in leraner_marksheet.learner_marksheet_data_scholastic" :key="index">
                                <td>
                                    <center>{{ index }}</center>
                                </td>
                                <td v-for="(sem1, index1) in s[0]" :key="index1">
                                    <center>{{ sem1 }}</center>
                                </td>
                                <td v-for="(sem2, index2) in s[1]" :key="index2">
                                    <center>{{ sem2 }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </div>
            <div class="div">
                <v-col cols="12">
                    <v-simple-table v-if="leraner_marksheet" dense class="marks-table">
                        <tbody>
                            <tr>
                                <template v-if="leraner_marksheet.is_admitted_for_term_1">

                                    <td>{{ leraner_marksheet.sem1 }} Max</td>
                                    <td style="color:blue">{{ leraner_marksheet.sem_over_all_marks_grade[0] }}</td>

                                    <td>{{ leraner_marksheet.sem1 }} Obtained</td>
                                    <td style="color:blue">{{ leraner_marksheet.sem_over_all_marks_grade[1] }}</td>

                                    <td>{{ leraner_marksheet.sem1 }} Percentage</td>
                                    <td style="color:blue">{{ leraner_marksheet.sem_over_all_marks_grade[2] }}</td>

                                    <td>{{ leraner_marksheet.sem1 }} Grade</td>
                                    <td style="color:blue">{{ leraner_marksheet.sem_over_all_marks_grade[3] }}</td>

                                </template>


                                <td>{{ leraner_marksheet.sem2 }} Max</td>
                                <td style="color:blue">
                                    {{ leraner_marksheet.sem_over_all_marks_grade[term2Index] }}
                                </td>

                                <td>{{ leraner_marksheet.sem2 }} Obtained</td>
                                <td style="color:blue">
                                    {{ leraner_marksheet.sem_over_all_marks_grade[term2Index + 1] }}
                                </td>

                                <td>{{ leraner_marksheet.sem2 }} Percentage</td>
                                <td style="color:blue">
                                    {{ leraner_marksheet.sem_over_all_marks_grade[term2Index + 2] }}
                                </td>

                                <td>{{ leraner_marksheet.sem2 }} Grade</td>
                                <td style="color:blue">
                                    {{ leraner_marksheet.sem_over_all_marks_grade[term2Index + 3] }}
                                </td>

                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </div>
            
            <div class="div">
                <v-col v-if="leraner_marksheet.is_admitted_for_term_1 == true" cols="12" sm="12" md="12">
                    <h2 class="pl-2 pb-2 colored-text">Part - 2 : Co-Scholastic Activities (to be assessed on a {{
                        leraner_marksheet.coscholastic_grade }}
                        point scale)
                    </h2>
                    <v-simple-table v-if="leraner_marksheet != ''" fixed-header dense class="elevation-1">
                        <thead>
                            <tr>
                                <td style="background-color: #f5e9c9;">
                                    <center>{{ leraner_marksheet.sem1 }}</center>
                                </td>
                                <td style="background-color: #f5e9c9;">
                                    <center>Grade</center>
                                </td>
                                <td style="background-color: #f5e9c9;">
                                    <center>{{ leraner_marksheet.sem2 }}</center>
                                </td>
                                <td style="background-color: #f5e9c9;">
                                    <center>Grade</center>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(
s, index2
            ) in leraner_marksheet.leraner_coscholastic_marksheet" :key="index2">
                                <td>
                                    <center>{{ index2 }}</center>
                                </td>
                                <td v-for="(sem1, index1) in s[0]" :key="index1">
                                    <center>{{ sem1 }}</center>
                                </td>
                                <td>
                                    <center>{{ index2 }}</center>
                                </td>
                                <td v-for="(sem2, index3) in s[1]" :key="index3">
                                    <center>{{ sem2 }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col v-else cols="12" sm="12" md="12">
                    <v-simple-table v-if="leraner_marksheet != ''" fixed-header dense class="elevation-1">
                        <thead>
                            <tr>
                                <td style="background-color: #f5e9c9;" colspan="4">
                                    <center>Co-Scholastic Areas</center>
                                </td>
                            </tr>
                            <tr>
                                <td style="background-color: #f5e9c9;">
                                    <center>{{ leraner_marksheet.sem2 }}</center>
                                </td>
                                <td style="background-color: #f5e9c9;">
                                    <center>Grade</center>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(
s, index2
            ) in leraner_marksheet.leraner_coscholastic_marksheet" :key="index2">
                                <td>
                                    <center>{{ index2 }}</center>
                                </td>
                                <td v-for="(sem2, index3) in s[1]" :key="index3">
                                    <center>{{ sem2 }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <br />
                <span
                    v-if="leraner_marksheet.is_admitted_for_term_1 == true && leraner_marksheet.leraner_other_marksheet != ''">
                    <v-col cols="12" sm="12" md="12">
                        <v-simple-table v-if="leraner_marksheet != ''" fixed-header dense class="elevation-1">
                            <thead>
                                <tr>
                                    <td style="background-color: #f5e9c9;">
                                        <center>{{ leraner_marksheet.sem1 }}</center>
                                    </td>
                                    <td style="background-color: #f5e9c9;">
                                        <center>Grade</center>
                                    </td>
                                    <td style="background-color: #f5e9c9;">
                                        <center>{{ leraner_marksheet.sem2 }}</center>
                                    </td>
                                    <td style="background-color: #f5e9c9;">
                                        <center>Grade</center>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(s, index2) in leraner_marksheet.leraner_other_marksheet" :key="index2">
                                    <td>
                                        <center>{{ index2 }}</center>
                                    </td>
                                    <td v-for="(sem1, index1) in s[0]" :key="index1">
                                        <center>{{ sem1 }}</center>
                                    </td>
                                    <td>
                                        <center>{{ index2 }}</center>
                                    </td>
                                    <td v-for="(sem2, index3) in s[1]" :key="index3">
                                        <center>{{ sem2 }}</center>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>                    
                </span>
                <span v-else>
                    <v-col cols="12" sm="12" md="12">
                        <v-simple-table v-if="leraner_marksheet != ''" fixed-header dense class="elevation-1">
                            <thead>
                                <tr>
                                    <td>
                                        <center>{{ leraner_marksheet.sem2 }}</center>
                                    </td>
                                    <td>
                                        <center>Grade</center>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(s, index2) in leraner_marksheet.leraner_other_marksheet" :key="index2">
                                    <td>
                                        <center>{{ index2 }}</center>
                                    </td>
                                    <td v-for="(sem2, index3) in s[1]" :key="index3">
                                        <center>{{ sem2 }}</center>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </span>
            </div>
            <br />
            <v-col cols="12" sm="12" md="12" class="tech-remark font-size">
                <v-simple-table class="student-info-table">
                    <tr>
                        <td class="label">Class Teacher's Remarks : </td>
                        <td style="font-size: 16px;">{{ leraner_marksheet.lms_remark }}</td>
                    </tr>
                </v-simple-table>
            </v-col>
            <v-col cols="12" sm="12" md="12">
                <v-simple-table>
                    <tr class="text-center spacing-row">

                        <td style="border-right: none;">
                            <strong>Class Teacher</strong>
                        </td>

                        <td style="border-right: none;">
                            <strong>Examination I/C.</strong>
                        </td>

                        <td>
                            <strong>Principal</strong>
                        </td>
                    </tr>
                </v-simple-table>
            </v-col>
            <v-col cols="12" sm="12" md="12" class="tech-remark font-size">
                <v-simple-table class="student-info-table">
                    <tr>
                        <td class="label">Date : </td>
                        <td class="value">{{ leraner_marksheet.lms_result_date }}</td>
                    </tr>
                </v-simple-table>
            </v-col>
            <br>
            <v-row justify="center" dense class="colored-text">
                <h2>Grading System</h2>
            </v-row>
            <v-col cols="12" sm="12" md="12">
                <v-row dense justify="center">
                    <v-col cols="12" sm="6" md="6">
                        <center>
                            <strong>Scholastic Areas: Part 1 <br />
                                (Grading on {{ leraner_marksheet.scholastic_grade }} Point Scale)</strong>
                        </center>
                        <v-simple-table dense class="elevation-1">
                            <thead>
                                <tr style="background-color: #f5e9c9;">
                                    <td class="">
                                        <center>Sr. No.</center>
                                    </td>
                                    <td class="">
                                        <center>Grade Name</center>
                                    </td>
                                    <td class="">
                                        <center>Percentage Range</center>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(s, index) in leraner_marksheet.grade_details" :key="s.g_id">
                                    <td>
                                        <center>{{ index + 1 }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.gradename }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.range }}</center>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="12" sm="1" md="1"> </v-col>
                    <v-col cols="12" sm="5" md="5">
                        <center>
                            <strong>
                                Co-Scholastic Areas: Part 2 <br />
                                (Grading on {{ leraner_marksheet.coscholastic_grade }} Point Scale)</strong>
                        </center>
                        <v-simple-table dense class="elevation-1">
                            <thead>
                                <tr style="background-color: #f5e9c9;">
                                    <td class="">
                                        <center>Sr. No.</center>
                                    </td>
                                    <td class="">
                                        <center>Grade Name</center>
                                    </td>
                                    <td class="">
                                        <center>Grade Point</center>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(s, index) in leraner_marksheet.cograde_details" :key="s.g_id">
                                    <td>
                                        <center>{{ index + 1 }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.gradename }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.range }}</center>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <br>
                        <div class="promotion-text">

                            <div>
                                Congratulations! Promoted to
                                <span class="fixed-line">
                                    Class {{ leraner_marksheet.next_std }}
                                </span>
                            </div>

                            <div class="mt-3">
                                New session begins on :
                                <span class="fixed-line">
                                    {{ leraner_marksheet.sessiondate_std }}
                                </span>
                            </div>

                        </div>

                    </v-col>
                </v-row>
            </v-col>
        </v-card> -->
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
        org: Number,
    },
    data() {
        return {
            default_value: [],
            overlay: false,
            snackbar: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            sel_ay_data: null,
            sem: null,
            show: false,
            awspath: "",
            registration_no: null,
            standard: null,
            div: null,
            ay: null,
            name: null,
            dob: null,
            roll_no: null,
            mobile_no: null,
            address: null,
            mother_name: null,
            photo: null,
            reg_no: null,
            gr_no: null,
            father_full_name: null,
            leraner_marksheet: [],
            semester: null,
            colspan: null,
            overall_grade: null,
            remark: [],
            org_basic_data: [],
            sem1: null,
            sem2: null,
            mother_contact: null,
            father_contact: null,
            aadhar_no: null,
            blood_group: null,
            rawhtmlcode:[],
            istemplateApplicable:false
        };
    },
    computed: {
        term2Index() {
            return this.leraner_marksheet.is_admitted_for_term_1 ? 4 : 0
        }
    },
    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            this.overlay = true;
            const data = {
                lid: this.registration_no,
                ay: this.sel_ay_data,
                sem: this.sem,
                org: this.org,
            };
            console.log("data:", data);
            axios
                .post("/Examination/getAnnualStudentReportTemplate", data)
                .then((res) => {
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.smsg); // show snackbar
                        this.overlay = false;
                        return;
                    }
                    if (res.data.flag == "YES") {
                        this.standard = res.data.standard;
                        this.div = res.data.div;
                        this.ay = res.data.ay;
                        this.name = res.data.name;
                        this.dob = res.data.dob;
                        this.roll_no = res.data.roll_no;
                        this.mobile_no = res.data.mobile_no;
                        this.address = res.data.address;
                        this.mother_name = res.data.mother_name;
                        this.aadhar_no = res.data.aadhar_no;
                        this.blood_group = res.data.blood_group;
                        this.photo = res.data.photo;
                        this.reg_no = res.data.reg_no;
                        this.gr_no = res.data.gr_no;
                        this.father_full_name = res.data.father_full_name;
                        this.leraner_marksheet = res.data.leraner_marksheet;
                        // console.log(this.leraner_marksheet)
                        this.semester = res.data.semester;
                        this.default_value = res.data.default_value;
                        this.org_basic_data = res.data.org_basic_data;
                        this.mother_contact = res.data.mother_contact;
                        this.father_contact = res.data.father_contact;
                        this.rawhtmlcode = res.data.output;
                        this.istemplateApplicable = res.data.istemplateApplicable;
                        this.overlay = false;
                    }
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                        this.overlay = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.overlay = false;
                })
                .finally(() => { });
        },
    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.sel_ay_data = localStorage.getItem("setay");
        this.sem = localStorage.getItem("setsem");
        this.registration_no = localStorage.getItem("setreg_no");
        this.onload();
    },
};
</script>
<style scoped>
@font-face {
    font-family: 'GregorianFLF';
    src: url("https://db.onlinewebfonts.com/t/39b0c3d169333ae5bb25727bfdbad96d.woff2") format("woff2"),
        url("https://db.onlinewebfonts.com/t/39b0c3d169333ae5bb25727bfdbad96d.woff") format("woff");
}

.header-style {
    font-family: serif;
    font-size: 2em;
    color: #b30000;
}

.header-style::first-letter {
    font-family: 'GregorianFLF', serif;
}

.header-style .span-first-letter {
    font-family: 'GregorianFLF', serif;
}

tr,
td,
th {
    border: 1px solid black;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
}

@page {
    size: A4;
    margin-bottom: 0;
    padding-top: none;
    size: 11in 15.5in;
}

@media print and (-webkit-min-device-pixel-ratio: 0) {
    .marks-table td {
        padding: 8px !important;
        font-size: 15px !important;
        font-weight: bold;
    }

    .student-info-table td {
        padding: 15px;
        font-size: 15px;
    }

    .attd-table td {
        padding: 15px !important;
    }

    .v-data-table__wrapper {
        overflow-x: hidden;
        overflow-y: hidden;
    }

    .card {
        border: none !important;
        margin-top: -25px !important;
    }

    .page-top {
        padding-top: 30px !important;
    }

    .pagebreak {
        page-break-before: always;
    }

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
        page-break-inside: auto;
    }

    body,
    tr,
    th,
    td {
        font-size: 22px !important;
        page-break-inside: auto;
        word-wrap: break-word;
    }

    .font-size {
        font-size: 24px !important;
    }

    .header-style {
        font-size: 50px !important;
    }

    .motto .society .affiliation .school-desc .subtitle {
        font-size: 18px;
    }

    .address-row .subtitle {
        font-size: 22px !important;
    }

    .student-photo {
        width: 210px !important;
        height: 210px !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    v-card {
        border: none !important;
    }

    thead {
        font-weight: bold !important;
    }

    table,
    tr,
    th {
        page-break-inside: auto;
    }

    .div {
        width: 1450px !important;
    }
}

.marks-table {
    width: 100%;
    border-collapse: collapse !important;
    table-layout: fixed;
}

.marks-table td {
    border: 1px solid #000;
    padding: 6px 8px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    white-space: nowrap;
}

.student-info-table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
}

.student-info-table td {
    border: 1px solid #000;
    padding: 8px 10px;
    font-size: 13px;
    vertical-align: middle;
}

.student-info-table .label {
    background-color: #f5e9c9;
    font-weight: bold;
    font-size: 17px;
    width: 25%;
}

.student-info-table .value {
    font-size: 15px;
}

.top-row {
    display: flex;
    align-items: center;
    justify-content: center;
}

.school-title {
    text-align: center;
}

.society {
    font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
}

.colored-text {
    color: #b30000;
    font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}

.promotion-text {
    line-height: 1.2;
}

.fixed-line {
    display: inline-block;
    min-width: 180px;
    text-align: center;
    border-bottom: 3px solid #000;
}

.motto {
    display: flex;
    gap: 12px;
    font-weight: 600;
    justify-content: center;
    align-items: center;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.motto .dot {
    color: #b30000;
    font-size: 20px;
    line-height: 1;
}


.school-desc {
    font-size: 13px;
    font-family: Arial, Helvetica, sans-serif;
}

.address-row {
    background: #f7edc8;
    padding: 8px;
    font-size: 15px;
    margin-top: 5px;
    font-weight: 600;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.spacing-row td {
    padding-top: 150px;
}

.report-title2 {
    font-size: 42px;
    font-weight: 900;
    color: #b30000;
    font-family: 'Cooper Black', 'Arial Rounded MT', cursive;

    /* INNER WHITE BORDER (tight) */
    text-shadow:
        -1px -1px 0 #ffffff,
        1px -1px 0 #ffffff,
        -1px 1px 0 #ffffff,
        1px 1px 0 #ffffff,

        /* OUTER DARK BORDER (gap controlled) */
        -3px -3px 0 #003366,
        3px -3px 0 #003366,
        -3px 3px 0 #003366,
        3px 3px 0 #003366,

        /* soft depth */
        4px 4px 6px rgba(0, 0, 0, 0.35);
}

.report-title {
    text-align: center;
    margin-top: 15px;
    font-weight: bold;
}

.report-title .title {
    font-size: 34px;
    color: #b30000;
    font-weight: bold;
    text-shadow: 1px 1px #000;
}

.report-title .subtitle {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.report-title .class {
    font-size: 26px;
    font-weight: bold;
    color: #b30000;
    margin-top: 8px;
}

.report-title-container {
    display: flex;
    margin-top: 15px;
}

.report-title {
    flex: 1;
    text-align: center;
}

.student-photo img {
    width: 190px;
    height: 190px;
}
</style>
